import { Model, type ModelProps } from '@/infra/model'
import { observable } from 'mobx'
import { Id } from '@/infra/id'
import type { ProviderPtinActiveStatus } from '@/features/iam/providers/Provider'

/**
 * User type.
 */
export type UserDataType = 'User' | 'Pro' | 'Admin' | 'CallAgent'

export type UserDataProps = ModelProps<UserData>

export class UserData extends Model<UserData> {
  @observable accessor userPublicId = Id.none
  @observable accessor userDataType: UserDataType = 'User'
  @observable accessor givenName = ''
  @observable accessor familyName = ''
  @observable accessor email = ''
  @observable accessor phone = ''
  @observable accessor workspaceSlugs: string[] = []
  @observable accessor jobCapacity = 0
  @observable accessor ptinStatus: ProviderPtinActiveStatus = 'NotApplicable'
}
